export const env = {
  apiUrl: import.meta.env.VITE_API_URL?.trim() || undefined,
  defaultPriceUrl: import.meta.env.VITE_DEFAULT_PRICE_URL?.trim() || undefined,
  // Куда уводить людей без действующей подписки: прайсинг Академии. Покупки в ЛК
  // больше нет (read-only, CloudPayments мёртв). Значение можно переопределить
  // сборочной переменной, дефолт — прод Академии.
  academyPricingUrl:
    import.meta.env.VITE_ACADEMY_PRICING_URL?.trim() || 'https://academy.productsense.io/pricing',
} as const
